import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {productsListSelector} from '../../../redux/selectors/products';
import View from './View';
import {getFormValues} from 'redux-form';
import {Forms} from '../../../shared/models/forms';
import {SearchBarForm} from '../SearchBar/model';
import {Platform} from 'react-native';

const paginationSize = Platform.OS === 'web' ? 12 : 5;

export const ProductsList = () => {
  const productsList = useSelector(productsListSelector());
  const searchProductQuery = useSelector(getFormValues(Forms.searchBarForm)) as SearchBarForm;
  const [visibleElementsCount, setVisibleElementsCount] = useState(paginationSize);
  const [searchedProducts, setSearchedProducts] = useState(productsList);

  const canShowMore = useMemo(
    () => (productsList?.length || 0) > visibleElementsCount,
    [productsList, visibleElementsCount],
  );

  useEffect(() => {
    if (!searchProductQuery && productsList) {
      setSearchedProducts(productsList);
    }
    if (searchProductQuery?.query && productsList) {
      const searchQuery = searchProductQuery.query.toLowerCase();
      setSearchedProducts((prev) => {
        const filteredVisibleProducts = productsList.filter((item) => {
          if (item.name?.toLowerCase().includes(searchQuery)) return item;
        });
        return filteredVisibleProducts;
      });
    }
  }, [searchProductQuery, productsList]);

  const visibleProductsList = searchedProducts ? searchedProducts.slice(0, visibleElementsCount) ?? [] : null;

  return (
    <View
      productsList={visibleProductsList}
      onShowMore={() => setVisibleElementsCount(visibleElementsCount + paginationSize)}
      canShowMore={canShowMore}
    />
  );
};
